import { render, staticRenderFns } from "./object-info.vue?vue&type=template&id=6a9f8cfe&"
import script from "./object-info.js?vue&type=script&lang=js&"
export * from "./object-info.js?vue&type=script&lang=js&"
import style0 from "./object-info.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./object-info.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports